import { useDispatch, useSelector } from 'react-redux';

import {
  Modal,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
} from '@frontend/components';

import { modal as nestModule } from '../data/actions';
import { isOpen } from '../data/reducer';
import { FullSizeErrorFallback } from './components';

const NestModuleErrorFallback = () => {
  const isDialogOpen = useSelector(isOpen);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(nestModule.setCurrentNextIndex(0));
    dispatch(nestModule.close());
  };

  return (
    <Modal size="full" isOpen={isDialogOpen} onClose={handleClose}>
      <ModalContent>
        <ModalHeader>
          Nesting
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <FullSizeErrorFallback />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default NestModuleErrorFallback;
